import React from "react";
import S from "./ContactForm.style";
import Title from "@/components/Title/Title";
import ContactComponent from "@/components/ContactComponent/ContactComponent";

export interface Props {
  title: string;
}

const ContactForm: React.FC<Props> = (data) => {
  
  return (
    <S.Container>
      <div className="main-inner">
        {data.title && <Title title={data.title} />}
        <ContactComponent backgroundColor="white" />
      </div>
    </S.Container>
  );
};

export default ContactForm;
